import { useModal } from 'components/Modals';
import { createContext, useContext, useState } from 'react';
import ForceVinModal from './modal';
import { DevicesType } from 'services/resources';
import colors from 'styles/colors';
import FlashMessage from 'components/FlashMessage';
import { FLASH_MESSAGE_TYPES } from 'constants/common';

const ForceVinContext = createContext(undefined);

const ForceVinModalProvider = ({ children }) => {
  const { openModal, closeModal, Modal, isOpen } = useModal({
    background: colors.modalBackground,
    programmaticallyOpen: true,
    closeOnOutsideClick: false,
  });
  const [device, setDevice] = useState<DevicesType | null>(null);

  const [flashMessageVisible, setFlashMessageVisible] = useState(false);
  const [flashMessageType, setFlashMessageType] = useState<FLASH_MESSAGE_TYPES | null>(null);
  const [flashMessage, setFlashMessage] = useState<string | null>(null);

  const addFlashMessage = (text: string, type: FLASH_MESSAGE_TYPES) => {
    setFlashMessageVisible(true);
    setFlashMessageType(type);
    setFlashMessage(text);
  };

  return (
    <ForceVinContext.Provider value={{ openModal, setDevice, device, closeModal, addFlashMessage }}>
      {children}
      {isOpen && (
        <Modal>
          <ForceVinModal />
        </Modal>
      )}
      <FlashMessage
        visible={flashMessageVisible}
        type={flashMessageType}
        text={flashMessage}
        onClose={() => {
          setFlashMessageVisible(false);
        }}
      />
    </ForceVinContext.Provider>
  );
};

export const useForceVin = () => {
  const context = useContext(ForceVinContext);
  if (!context) {
    throw new Error('useForceVin must be used within a ForceVinModalProvider');
  }

  return context;
};

export default ForceVinModalProvider;
